import React, { useContext } from "react"
import {
  Box,
  Flex,
  Text,
  Heading,
  useColorModeValue,
  Link,
  Container,
  Stat
} from "@chakra-ui/react"
import Image from "next/image"
import IdentifyTrack from "../../public/img/experience.png"
import Review from "../../public/img/business-metrics-health.png"
import styles from "../../styles/solutions.module.css"
import Meta from "../../components/meta/Meta"
import ButtonPrimary from "../../components/buttons/PrimaryButton"
import { CheckIcon } from "@chakra-ui/icons"
import NextLink from "next/link"
import { Accordion } from "@chakra-ui/accordion"
import AccordionMenu from "../../components/accordion/AccordionMenu"
import { topSellersByDomainFaq } from "../../data/TopSellersByDomainFaq"
import { DomainContext } from "../../components/context/DomainContext"

export default function TopSellerByDomain() {
  const textColor = useColorModeValue("gray.500", "white")
  const domainContextVal = useContext(DomainContext)

  function ButtonClick() {
  }
  return (
    <>
      <Meta
        pageName={"Find Top Amazon Sellers by Domain - TrackSellers"}
        description={"Find the top Amazon sellers by domain from our directory of 5 Million Amazon sellers across 12 Amazon marketplaces. Get sellers ranking & more. "}
        hrefLink={"https://www.tracksellers.com/top-sellers-by-domain"}
      />
      <Box className={styles.ReportMainBox}>
        <Container maxW="container.xl">
          <Box pb="1rem">
            <Box className={styles.ReportSubBox}>
              <Heading as={"h1"} mb="18px" className={styles.ReportHead} >
                Top Amazon Sellers By Domain
              </Heading>
              <Text fontSize={{ base: "1.2rem", md: "1.2rem", lg: "1.5rem" }} className={styles.ReportTextHeading} mt="1rem" maxW={{ base: "100%", md: "100%", lg: "75%" }}>
                Stay ahead in the competitive Amazon marketplace with our comprehensive and accurate seller ranking system across 12 domains.
              </Text>
            </Box>
          </Box>
          <Box pt="0rem">
            <Box>
              <Flex
                pb={{ base: "0rem", md: "2rem", lg: "2rem" }}
                pt={{ base: "1rem", md: "0rem", lg: "0rem" }}
                mb={{ base: "20px", md: "50px" }}
                display={{ base: "flex", md: "flex", lg: "flex" }}
                alignItems={{ base: "flex-start", md: "flex-start", lg: "center" }}
                direction={{ base: "column", sm: "column", md: "column", lg: "row" }}>
                <Box flex="1" className={styles.SellerIntelligenceReportImage}>
                  <Image
                    src={IdentifyTrack}
                    alt="IdentifyTrack"
                  />
                </Box>
                <Box flex="1"
                  pl={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pr={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pt={{ base: "2rem", sm: "2rem", md: "2rem", lg: "0rem" }}>
                  <Stat me="auto">
                    <Heading color="#243e63" fontSize={{ base: "1.2rem", md: "2rem", lg: "2rem" }}
                      mb={{ base: "5px", md: "10px", lg: "10px" }}
                    >
                      Specific Amazon Seller Rankings to Find Top Amazon Sellers by Domain
                    </Heading>
                    <Box mt="0.5rem">
                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          Seller rankings for each of the 12 Amazon marketplaces, giving you insight into your performance in different markets.
                        </Text>
                      </Flex>
                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          Our vast database of approximately 5 million sellers ensures accurate representation of seller performance.
                        </Text>
                      </Flex>
                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          We consider a range of metrics such as review counts, product prices, sales estimates, and order estimates, with the primary factor being the number of reviews received in the last 12 months.
                        </Text>
                      </Flex>
                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          Rankings are updated monthly to provide you with the most current information.
                        </Text>
                      </Flex>

                    </Box>
                  </Stat>
                </Box>
              </Flex>
            </Box>
            <Box>
              <Flex
                pb={{ base: "0rem", md: "2rem", lg: "2rem" }}
                pt={{ base: "1rem", md: "0rem", lg: "0rem" }}
                mb={{ base: "20px", md: "50px" }}
                display={{ base: "flex", md: "flex", lg: "flex" }}
                alignItems="center"
                direction={{ base: "column-reverse", md: "column-reverse", lg: "row" }}>
                <Box flex="1"
                  pt={{ base: "2rem", sm: "2rem", md: "2rem", lg: "0rem" }}>
                  <Heading color="#243e63" fontSize={{ base: "1.2rem", md: "2rem", lg: "2rem" }} mb="15px">
                    Comprehensive Amazon Seller Profiles from Multiple Domains for Informed Decision Making
                  </Heading>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w={{ base: "100%", md: "100%", lg: "80%", xl: "80%" }} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Our seller profile pages offer a more complete understanding of seller performance with lifetime and 30-day ranks in addition to marketplace-specific ranks.
                    </Text>
                  </Flex>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    Identify trends and make data-driven decisions on potential partnerships or competition strategies.
                  </Flex>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    Compare and contrast sellers across different Amazon marketplaces to better grasp the global market landscape.
                  </Flex>
                </Box>
                <Box flex="1" className={styles.SellerIntelligenceReportImage}>
                  <Image
                    src={Review}
                    alt="Review"
                  />
                </Box>
              </Flex>
            </Box>
          </Box>
        </Container>
        <Box mt="2rem" mb="2rem" textAlign="center" >
          <Text fontSize={{ base: "1rem", md: "1.2rem", lg: "1.2rem" }} color={textColor} className={styles.ReportText} mt="0.5rem" maxW={{ base: "100%", md: "100%", lg: "70%" }}>
            Unlock The Power Of Amazon Seller Rankings
          </Text>
          <Text fontSize={{ base: "1rem", md: "1.2rem", lg: "1.2rem" }} color={textColor} className={styles.ReportText} mt="0.5rem" mb="1.5rem" maxW={{ base: "100%", md: "100%", lg: "70%" }}>
            Get started with TrackSellers.com today and gain insights into your performance and competition in the ever-evolving Amazon marketplace.
          </Text>
          <NextLink href={`/sellers/by-domain/${domainContextVal.code}`} passHref>
            <Link >
              <ButtonPrimary ButtonClick={ButtonClick} buttonName="Get Started" />
            </Link>
          </NextLink>
        </Box>
        <Box pt="4rem" pb="4rem" pl="15px" pr="15px" background="#fff">
          <Box className={styles.LeadFaqBox}>
            <Heading className={styles.LeadFaqHead}>
              Frequently Asked Questions
            </Heading>
            <Accordion w="100%" maxWidth="800px" allowToggle defaultIndex={[0]} allowMultiple={false}>
              {
                topSellersByDomainFaq?.map((ques, index) => (
                  <AccordionMenu {...ques} key={index} />))
              }
            </Accordion>
          </Box>
        </Box>
      </Box>
    </>
  )
}